import { Injectable } from '@angular/core';
import { IrdBrandValue } from '@ird/shared-utils';

export type BrandDefaultImages = {
  asset: string;
  sparePartKit: string;
  noAssetsFoundRestricted: string;
  noAssetsFound: string;
};

const defaultImagePrefix = 'https://azure-na-images.contentstack.com/v3/assets';

const IR_DEFAULT_IMAGES: BrandDefaultImages = {
  asset: `${defaultImagePrefix}/blte1f4802db5e35981/bltca2951ee3cf3e8b3/IR-Default-Asset-Picture.png`,
  sparePartKit: `${defaultImagePrefix}/blte1f4802db5e35981/bltab6a33a3902f17f5/default-spare-parts.png`,
  noAssetsFoundRestricted: `${defaultImagePrefix}/blte1f4802db5e35981/blt93467225fd1887e3/HomeScreen.png`,
  noAssetsFound: `${defaultImagePrefix}/blte1f4802db5e35981/bltd410b0d59439d604/68cd4fd8fd7f720602561342/No_Assets_Found.png`,
};

const BRANDS_DEFAULT_IMAGES_MAP: Record<IrdBrandValue, BrandDefaultImages> = {
  [IrdBrandValue.IR]: IR_DEFAULT_IMAGES,
  [IrdBrandValue.GD]: IR_DEFAULT_IMAGES,
};

@Injectable({
  providedIn: 'root',
})
export class BrandsDefaultImagesService {
  getBrandDefaultImages(brand: IrdBrandValue): BrandDefaultImages {
    const images = BRANDS_DEFAULT_IMAGES_MAP[brand];
    if (!images) {
      console.warn(`Default images not found for brand: ${brand}, using IR as fallback`);
      return IR_DEFAULT_IMAGES;
    }
    return images;
  }
}
